import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ProfileService } from 'src/app/profile-home/service/profile.service';
import { Profile } from 'src/app/core/models/profile';
import { SnackbarService } from '../snackbar/service/snackbar.service';
import { isPhoneValid, removeMask } from 'src/app/core/constants/flag-Input-const';

@Component({
  selector: 'app-modal-edit',
  templateUrl: './modal-edit.component.html',
  styleUrls: ['./modal-edit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalEditComponent implements OnInit {

  @Input()
  public showEdit = false;

  @Input()
  public nameUser: string;

  @Output() sendOpen = new EventEmitter<boolean>();

  public form: FormGroup;

  public showLoader = false;
  public showLocaltion = false;
  public showType = false;
  public indexId = null;

  public locations = [];
  public listType = [];
  public idiomas = [];

  public banner = '../../../../assets/svgs/banner.svg';
  public profile = 'https://bucketsquadcrm.s3.amazonaws.com/default_images/profile_default.jpg';

  constructor(
    private fb: FormBuilder,
    private service: ProfileService,
    private router: Router,
    private snackService: SnackbarService
   ) { }

  ngOnInit() {
    this.initForm();
    this.findByUserName();
    this.getLanguages();
  }

  public initForm() {
    this.form = this.fb.group({
      id: [null],
      banner_image_url: [null],
      profile_image_url: [null],
      name: [null],
      nickname: [null],
      is_editable: [true],
      state: [null],
      country: [null],
      phone: [{ddi: '', phone: ''}],
      alternative_phone: [{ddi: '', phone: ''}],
      email: [null],
      biography: [' ', [Validators.maxLength(280)]],
      designacao_tecnica: [null],
      technical_designation: [null],
      creci: [null],
      company: [null],
      languages: [[]],
      profile_url: [null]
    });
  }

   findByUserName() {
    this.service.findByName(this.nameUser).subscribe((response: Profile) => {
      for (const key in response) {
        if (response.hasOwnProperty(key)) {
          this.form.get(key).setValue(response[key]);
        }
      }
    }, () => this.router.navigate(['/nao-encontrado']));
  }

  getLanguages() {
    this.service.findLanguages().subscribe(x => {
      this.locations = x.languages;
      this.listType = x.proficiencia;
    });
  }

  setPhone(event, source) {
    if (source === 1) {
      this.form.get('phone').setValue(event);
    }
    if (source === 2) {
      this.form.get('alternative_phone').setValue(event);
    }
  }

  // ADD - OK
  public addIdioma() {
    this.idiomas = [];
    if (this.form.get('languages').value !== null) {
      this.form.get('languages').value.map(x => this.idiomas.push(x));
    }
    this.idiomas.push({
      language: 'Selecione',
      proficiency: 'Selecione'
    });
    this.form.get('languages').setValue(this.idiomas);
  }

  // UPDATE IDIOMA AND TYPE
  public setIdioma(index: number, event: string, lt: string) {
    if (this.form.get('languages').value !== null) {
      this.form.get('languages').value.map((x, i: number) => {
        if (index === i && lt === 'loc') {
          x.language = event;
          this.showLocaltion = false;
        }
        if (index === i && lt === 'tp') {
          x.proficiency = event;
          this.showType = false;
        }
      });
    }
  }

  // CLEAR - OK
  public clearIdioma(index: number) {
    this.form.get('languages').value.splice(index, 1);
  }

  // SUBMITED
  public submitForm() {
    if (!this.form.get('phone').value.phone || !isPhoneValid(this.form.get('phone').value)) {
      this.snackService.show('Por favor, insira um número de telefone principal válido.', 'warning', 10 );
      return;
    }
    if (!isPhoneValid(this.form.get('alternative_phone').value)) {
      this.snackService.show('Por favor, insira um número de telefone alternativo válido.', 'warning', 10 );
      return;
    }
    const data = this.dataObj();
    this.sendUpdate(data);
  }

  public dataObj(): any {
    return {
      phone: removeMask(this.form.get('phone').value),
      alternative_phone: removeMask(this.form.get('alternative_phone').value),
      biography: this.form.get('biography').value,
      languages: this.form.get('languages').value.filter(x => x.language !== 'Selecione' && x.proficiency !== 'Selecione')
    };
  }

  public sendUpdate(data) {
    this.showLoader = true;
    this.service.profileEdit(data).subscribe((response) => {
      this.validatorRequesty(response);
    }, (e) => {
      this.snackService.show(e.error.messages ? e.error.messages[0].message : 'Não foi possível salvar as alterações', 'error');
      this.showLoader = false;
    });
  }

   validatorRequesty(data) {
    if (data.status.id === 0) {
      this.snackService.show('Dados atualizados com sucesso', 'success');
      this.showEdit = false;
      this.sendOpen.emit(this.showEdit);
      this.showLoader = false;
    }
    if (data.status.id === 1) {
      this.snackService.show(data.error.messages ? data.error.messages[0].message : 'Não foi possível salvar as alterações', 'error');
      this.showLoader = false;
    }
  }

}
